import { FinanceInvoice, InvoicePaymentMethods } from '@/api/models/finance'

import { BalanceInvoiceMap, BalanceInvoiceProp } from './BillsPayDrawer.types'

export const isInvoice = (
  invoice: BalanceInvoiceProp
): invoice is FinanceInvoice => 'id' in invoice

export const getBalanceInvoiceId = (
  invoice: BalanceInvoiceProp,
  [invoiceId]: string[] = []
) => ('id' in invoice ? invoice.id : invoiceId)

export const getBalanceInvoice = (
  invoice: BalanceInvoiceProp,
  paymentMethods?: InvoicePaymentMethods
): BalanceInvoiceMap => ({
  id: getBalanceInvoiceId(invoice),
  name: invoice.name,
  debtSum: invoice.debtSum,
  totalSum: 'totalSum' in invoice ? invoice.totalSum : undefined,
  invoicePeriod: 'invoicePeriod' in invoice ? invoice.invoicePeriod : undefined,
  customerName: 'customerName' in invoice ? invoice.customerName : undefined,
  premiseName: 'premiseName' in invoice ? invoice.premiseName : undefined,
  merchId:
    'merchId' in invoice ? invoice.merchId : paymentMethods?.acquiring?.merchId
})
